import React from "react";
import { Badge } from "components/ui/badge";
import { CheckCircle, XCircle, Clock, Loader2 } from "lucide-react";

interface StatusProps {
  status: string;
}

const Status: React.FC<StatusProps> = ({ status }) => {
  const getStatusConfig = (status: string) => {
    switch (status.toLowerCase()) {
      case "success":
        return {
          label: "Success",
          className:
            "bg-green-100 text-green-800 border-green-200 hover:bg-green-100",
          icon: CheckCircle,
        };
      case "failure":
        return {
          label: "Failed",
          className: "bg-red-100 text-red-800 border-red-200 hover:bg-red-100",
          icon: XCircle,
        };
      case "pending":
        return {
          label: "Pending",
          className:
            "bg-yellow-100 text-yellow-800 border-yellow-200 hover:bg-yellow-100",
          icon: Clock,
        };
      case "processing":
        return {
          label: "Processing",
          className:
            "bg-blue-100 text-blue-800 border-blue-200 hover:bg-blue-100",
          icon: Loader2,
        };
      default:
        return {
          label: status,
          className:
            "bg-gray-100 text-gray-800 border-gray-200 hover:bg-gray-100",
          icon: Clock,
        };
    }
  };

  const config = getStatusConfig(status);
  const IconComponent = config.icon;

  return (
    <Badge variant="outline" className={config.className}>
      <IconComponent className="h-3 w-3 mr-1" />
      {config.label}
    </Badge>
  );
};

export default Status;
